import React from 'react'

export default function HowNftWorks() {
  return (
<div className="howitwork-wrapper py-5">
  <div className="container-wide py-lg-5">
    <div className="row justify-content-center">
      <div className="col-lg-8 text-center d-flex justify-content-center gap-2 pb-75">
        <h2 className="text-gray-900 rajdhani-600 h1 mb-0 dark-text">How Avatar Lab works</h2>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-3 col-md-6 lg-mb-3 howitwork-div d-flex flex-column justify-content-center text-center">
        <i className="rounded-pill bg-facebook btn btn-icon btn-xl mx-auto bi-wallet-fill text-white font-lg" />
        <h6 className="rajdhani-600 mt-3 mb-2 h5 text-gray-900 dark-text">Register Account</h6>
        <p className="text-gray-600 dark-text rajdhani-600 mt-0 font-sm px-xl-3 lh-26 mb-0">Sign up for a free account in just a few clicks. Register using Metamask, WalletConnect or Social Login.</p>
      </div>
      <div className="col-lg-3 col-md-6 lg-mb-3 howitwork-div d-flex flex-column justify-content-center text-center">
        <i className="rounded-pill bg-success btn btn-icon btn-xl mx-auto bi-send-fill text-white font-lg" />
        <h6 className="rajdhani-600 mt-3 mb-2 h5 text-gray-900 dark-text">Create Avatar</h6>
        <p className="text-gray-600 dark-text rajdhani-600 mt-0 font-sm px-xl-3 lh-26 mb-0">Create unique avatars. Choose from a variety of features, hairstyles, and outfits to make it truly yours.</p>
      </div>
      <div className="col-lg-3 col-md-6 lg-mb-3 howitwork-div d-flex flex-column justify-content-center text-center">
        <i className="rounded-pill bg-warning btn btn-icon btn-xl mx-auto bi-shield-shaded text-white font-lg" />
        <h6 className="rajdhani-600 mt-3 mb-2 h5 text-gray-900 dark-text">Add Avatar Details</h6>
        <p className="text-gray-600 dark-text rajdhani-600 mt-0 font-sm px-xl-3 lh-26 mb-0">Set Avatar name and desired price and watch the offers roll in.</p>
      </div>
      <div className="col-lg-3 col-md-6 lg-mb-3 howitwork-div d-flex flex-column justify-content-center text-center">
        <i className="rounded-pill bg-skype btn btn-icon btn-xl mx-auto bi-bookmark-fill text-white font-lg" />
        <h6 className="rajdhani-600 mt-3 mb-2 h5 text-gray-900 dark-text">List it for sale or Rent</h6>
        <p className="text-gray-600 dark-text rajdhani-600 mt-0 font-sm px-xl-3 lh-26 mb-0">Put your avatar up for sale or rent and let others enjoy its charm.</p>
      </div>
    </div>
  </div>
</div>

  )
}
